import type { HTMLAttributes } from 'react';
import { cn } from '@worldcoo/ui/lib/utils';

export function Layout(props: HTMLAttributes<HTMLElement>) {
	return <main {...props} />;
}

export function Title(props: HTMLAttributes<HTMLHeadingElement>) {
	return <h1 {...props} className={cn('text-3xl font-bold md:text-5xl', props.className)} />;
}

export function Paragraph(props: HTMLAttributes<HTMLParagraphElement>) {
	return <p {...props} className={cn('text-lg md:text-xl', props.className)} />;
}
